import { Component } from '@angular/core';
declare var require: any;

@Component({
    selector: 'MentisSoft-Footer',
    template: require('./footer.template.html'),
    styles: [require('./footer.css')]
})

export class FooterComponent {
    footerText: string = 'Copyright (c) 2011-2016 MentisSoft. - All Rights Reserved';
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/footer/footer.Component.ts